import { render, staticRenderFns } from "./purchasedVoucherPlanTable.vue?vue&type=template&id=2fcdf70a&"
import script from "./purchasedVoucherPlanTable.vue?vue&type=script&lang=js&"
export * from "./purchasedVoucherPlanTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports